module.exports = __webpack_public_path__ + "distribution/img/bei1.0883e22d.png";